/**
 * Competitor Pricing — React Router route tree.
 *
 * Wires the page to its URL and applies the no-side-nav `AppLayout`
 * (MPCS is reachable by direct URL only — see `routes.ts`). Exports a
 * single `mpcsRouteGroups` array that `router.tsx` spreads in.
 */

import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import Box from '@amzn/awsui-components-core/box';
import Spinner from '@amzn/awsui-components-core/spinner';
import AppLayout from 'src/components/app/AppLayout';
import { RouteErrorBoundary } from 'src/components/ErrorBoundary';
import { ROUTES } from 'src/routes/mpcs/routes';

const GetCompetitorPricingPage = lazy(
  () => import('src/components/pages/mpcs/GetCompetitorPricingPage'),
);

const PageFallback = () => (
  <Box textAlign="center" padding={{ top: 'xxl' }}>
    <Spinner size="large" />
  </Box>
);

export const mpcsRouteGroups: RouteObject[] = [
  {
    element: <AppLayout />,
    children: [
      {
        path: ROUTES.HOME,
        element: (
          <Suspense fallback={<PageFallback />}>
            <GetCompetitorPricingPage />
          </Suspense>
        ),
        errorElement: <RouteErrorBoundary />,
      },
    ],
  },
];
